import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {formatDate} from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { ClassificationCService } from 'src/app/services/ClassificationCService';
import { CategoryModel } from 'src/app/models/ClassificationModel';
import swal from 'sweetalert2';
import { ContCategorySearchComponent } from '../cont-category-search/cont-category-search.component';


@Component({
  selector: 'app-cont-category',
  templateUrl: './cont-category.component.html',
  styleUrls: ['./cont-category.component.css']
})
export class ContCategoryComponent implements OnInit {
  catCode ='' ;
  catName ='' ;
  catNotes ='' ;
  userID ='sa' ;
  compCode ='1' ;
  modifaiedDate = '2021-01-01';

  constructor(  public contcateegoryservice : ClassificationCService,
    public contcategory : CategoryModel,
    public translate: TranslateService,
    public storage: LocalStorageService,
    private dialogref: MatDialog,
    public contcategorySelectedData : CategoryModel,) { }

  ngOnInit(): void {
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchArabic(){
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchEnglish(){
    this.translate.use('en');
    document.documentElement.dir = "ltr";
  }
  retriveCategory(){
    this.contcateegoryservice.getCategory(this.catCode,).subscribe(
      (data: CategoryModel) => {

        this.catCode = data.catCode;
        this.catName = data.catName;
        this.catNotes = data.catNotes;

        this.userID = data.userID;
        this.modifaiedDate = data.modifaiedDate;
        this.compCode = data.compCode;

      }
    );
  }
  submitCategory(){
    if (this.catCode == '' || this.catCode == null) {
      return;
    }

    this.contcategory.catCode = this.catCode;
    this.contcategory.catName = this.catName;
    this.contcategory.catNotes = this.catNotes;

    this.contcategory.userID = this.storage.retrieve('stguserId');
    this.contcategory.modifaiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.contcategory.compCode = this.storage.retrieve('stgcompcode');
    this.contcateegoryservice.AddCategory(this.contcategory).subscribe(data => {
    this.mesgSave();
    },
      error => { alert(error); }
    );
  }
  DeleteClass(){
    this.contcateegoryservice.DeleteCategory(this.catCode).subscribe(
      (data: CategoryModel) => {
      }
    );
    this.NewData();
  }
  MesgDelete(){
    swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(
      () => {
        this.DeleteClass();
        swal('Deleted!', 'Your record has been deleted.', 'success');
      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
  NewData(){
    this.catCode = '';
    this.catName='';
    this.catNotes='';
  }
  mesgSave() {
    swal({
    title: 'Your work has been saved',

    type: 'success',
    showConfirmButton: false,

    timer: 1500
    });
  }
  openDialog(){
    const dialogRef = this.dialogref.open(ContCategorySearchComponent,
      {
        data: {
          dataKey: this.contcategorySelectedData
        }
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.catCode = result.catCode;
        this.catName = result.catName;
        this.catNotes = result.catNotes;

        this.compCode = result.compCode;
        this.userID = result.userID;
        this.modifaiedDate = result.modifiedDate;
        this.retriveCategory();
        dialogSubmitSubscription.unsubscribe();
      });
  }

}
